module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-non-bodymatter element-container-single element-type-toc",
    attrs: {
      "epub:type": "toc",
      "id": "table-of-contents",
      "role": "doc-toc"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-small heading-format-reduced heading-alignment-fixed heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_vm._v("CONTENTS")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-contents text"
  }, [_c('div', {
    staticClass: "toc-frontmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/newslettersignup"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Newsletter sign-up")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-bodymatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/sunday"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("SUNDAY")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("1. ")]), _c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Brief Encounters")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('a', {
    attrs: {
      "href": "#/monday"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("MONDAY")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("2. ")]), _c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("A Helping Hand")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("3. ")]), _c('a', {
    attrs: {
      "href": "#/chapter003"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("A Client and a Case")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("4. ")]), _c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Background")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("5. ")]), _c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Case File")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("6. ")]), _c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Early Steps")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/tuesday",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("TUESDAY")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("7. ")]), _c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Missing Pieces")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("8. ")]), _c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Shadow of Doubt")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("9. ")]), _c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Beauty and the Prince")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("10. ")]), _c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Wish Upon a Hearth")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/wednesday",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("WEDNESDAY")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("11. ")]), _c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Plant Pathways")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("12. ")]), _c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Brother Valeron")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("13. ")]), _c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Bearers of Bad News")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("14. ")]), _c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("To Catch a Thief")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("15. ")]), _c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Meetings at the Open Hearth")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("16. ")]), _c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Just a Cup of Tea?")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/thursday",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("THURSDAY")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("17. ")]), _c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Leech")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("18. ")]), _c('span', {
    attrs: {
      "href": "#/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Morning After")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("19. ")]), _c('span', {
    attrs: {
      "href": "#/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Picking Up Speed")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("20. ")]), _c('span', {
    attrs: {
      "href": "#/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Viola Braeman")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("21. ")]), _c('span', {
    attrs: {
      "href": "#/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Scene of the Crime")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("22. ")]), _c('span', {
    attrs: {
      "href": "#/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Emerging Picture")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("23. ")]), _c('span', {
    attrs: {
      "href": "#/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Smoking Gun")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("24. ")]), _c('span', {
    attrs: {
      "href": "#/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("A Case Reopened")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/friday",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("FRIDAY")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("25. ")]), _c('span', {
    attrs: {
      "href": "#/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Confrontation")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("26. ")]), _c('span', {
    attrs: {
      "href": "#/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("A Moment of Clarity")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("27. ")]), _c('span', {
    attrs: {
      "href": "#/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("The Price of Justice")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    staticClass: "toc-item-number"
  }, [_vm._v("28. ")]), _c('span', {
    attrs: {
      "href": "#/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Aftermath")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-backmatter-group"
  }, [_c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/youwillalsoenjoy",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("You will also enjoy:")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/newslettersignup2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Newsletter sign-up")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("Acknowledgements")])])])]), _vm._v(" "), _c('div', {
    staticClass: "toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children"
  }, [_c('p', {
    staticClass: "toc-content toc-item-title"
  }, [_c('span', {
    attrs: {
      "href": "#/anotefromthepublisher",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-item-title-text cspan"
  }, [_vm._v("A note from the publisher")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-624f1122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 66
// module chunks = 0